import React from 'react';
import { BasicFacet, BasicFacetValue } from '../types';
import { availabilityStatusMap } from "../utils/constants";

interface AvailabilityFacetComponentProps {
  facet: BasicFacet;
  facetKey: string;
  isExpanded: boolean;
  selectedFilters: Record<string, Set<string>>;
  onFilterChange: (facetKey: string, value: BasicFacetValue, checked: boolean, type: string | null) => void;
  sanitizeFilterValue: (value: string) => string;
  isFilterSelected: (facet: BasicFacet, value: BasicFacetValue) => boolean;
}

// Availability status mapping

export const AvailabilityFacetComponent: React.FC<AvailabilityFacetComponentProps> = ({
  facet,
  facetKey,
  isExpanded,
  onFilterChange,
  sanitizeFilterValue,
  isFilterSelected
}) => {

  // Get the label for a numeric availability value
  const getAvailabilityLabel = (value: string): string => {
    return availabilityStatusMap[value] || value;
  };

  if (!isExpanded) {
    return null;
  }

  // For non-numeric facets, render checkboxes with availability labels
  return (
    <div className="space-y-1">
      {facet.values.map((item: BasicFacetValue) => {
        const sanitizedFilter = sanitizeFilterValue(item.filter);
        const availabilityLabel = getAvailabilityLabel(sanitizedFilter);

        return (
          <div key={item.filter} className="flex items-top">
            <input
              type="checkbox"
              id={`${facetKey}-${sanitizedFilter}`}
              checked={isFilterSelected(facet, item)}
              onChange={(e) => onFilterChange(facetKey, item, e.target.checked, facet.type)}
              className="mr-2 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <label
              htmlFor={`${facetKey}-${sanitizedFilter}`}
              className="text-sm text-gray-700 cursor-pointer flex items-top justify-between w-full"
            >
              <span>{availabilityLabel}</span>
              <span className="text-xs text-gray-500 ml-1">({item.count})</span>
            </label>
          </div>
        );
      })}
    </div>
  );
};